module.exports = __webpack_public_path__ + "img/noimg.1787a266.jpg";